import Loadable from 'my-components/Loadable';

export { default } from './FlashCardsManagerCtnr';

export const FlashCardDeckEditPage = Loadable(
  () => import(/* webpackChunkName: "flash-cards-manager" */ './FlashCardDeckEditPageCtnr'),
);
